import { forwardRef } from "react";
import PropTypes from "prop-types";
import MDInputRoot from "components/MDInput/MDInputRoot";

const MDInput = forwardRef(({ error, success, disabled, required, ...rest }, ref) => (
  <MDInputRoot
    {...rest}
    ref={ref}
    ownerState={{ error, success, disabled, required }}
    sx={{
      width: "100%",
      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      "& .MuiInputLabel-root": {
        paddingTop: "6px",
        paddingBottom: "6px",
        fontSize: "0.875rem",
      },
      "& .MuiInputBase-root": {
        paddingTop: "10px",
      },
    }}
  />
));

// Setting default values for the props of MDInput
MDInput.defaultProps = {
  error: false,
  success: false,
  disabled: false,
  required: false,
};

// Typechecking props for the MDInput
MDInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

export default MDInput;
